function getCookieValue(name) {
    const cookieArr = document.cookie.split('; ');
    const selectedCookie = cookieArr.find((cookie) => {
        const [cookieName] = cookie.split('=');
        return cookieName === name;
    });
    return selectedCookie ? decodeURIComponent(selectedCookie.split('=')[1] || '') : null;
}
export const getToken = (tokenKey) => {
    const keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        ['localstorage', 'sessionstorage', 'cookie'].includes(keyStructure[0].toLowerCase())) {
        const storageType = keyStructure[0].toLowerCase();
        const key = keyStructure[1];
        if (storageType === 'localstorage') {
            const value = localStorage.getItem(key);
            try {
                return JSON.parse(value !== null && value !== void 0 ? value : '');
            }
            catch (_a) {
                return value;
            }
        }
        if (storageType === 'sessionstorage') {
            const value = sessionStorage.getItem(key);
            try {
                return JSON.parse(value !== null && value !== void 0 ? value : '');
            }
            catch (_b) {
                return value;
            }
        }
        if (storageType === 'cookie') {
            return getCookieValue(key);
        }
    }
    return null;
};
export const getTokenDetails = (tokenKey) => {
    const keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        (keyStructure[0].toLocaleLowerCase() === 'localstorage' ||
            keyStructure[0].toLocaleLowerCase() === 'cookie')) {
        return {
            type: keyStructure[0].toLocaleLowerCase(),
            key: keyStructure[1],
        };
    }
    return null;
};
